import styled, { css } from "styled-components";
import {
  Button as ButtonPrimitive,
  ListBox as ListBoxPrimitive,
} from "react-aria-components";
import { useDesignTokens } from "@boi/react-design-tokens";

import * as S from "../TextInputV2/TextInputV2.styled";
import { useScrollShadowMixin } from "../ScrollShadow";

export const Group = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1fr auto;
`;

export const Input = styled(S.Input)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { select } = tokens;

    return css`
      height: 100%;
      padding-left: ${select.button.padding.left};

      &[data-disabled] {
        cursor: not-allowed;
      }
    `;
  }}
`;

export const ButtonBase = styled(ButtonPrimitive)`
  all: unset;
  box-sizing: border-box;
  cursor: pointer;

  &[data-disabled] {
    cursor: not-allowed;
  }
`;

export const Button = styled(ButtonBase)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { select } = tokens;

    return css`
      height: 100%;
      padding-left: ${select.button.gap};
      padding-right: ${select.button.padding.right};
    `;
  }}
`;

export const ListBox = styled(ListBoxPrimitive)`
  ${() => {
    const { tokens } = useDesignTokens();
    const { select } = tokens;

    const scrollShadowMixin = useScrollShadowMixin();

    return css`
      outline: none;
      overflow-y: auto;

      ${scrollShadowMixin}

      .react-aria-ListBoxSection:not(:empty, :last-of-type) {
        border-bottom-width: 3px;
        border-bottom-style: ${select.menu.separator.style};
        border-bottom-color: ${select.menu.separator.color};
      }
    `;
  }}
`;
